<template>
    <el-container>
        <el-header>
            <div class="header-left">
                <router-link to="/"><img class="logo" src="../../assets/images/logo.png"></router-link>
            </div>
            <div class="header-right" style="display: none;">
                <span class="item"><router-link to="/reg"><i class="iconfont iconzhuce-"></i> 注册</router-link></span>
            </div>
        </el-header>
        <el-main>
            <el-card class="box-card">
                <el-tabs v-model="activeName" @tab-click="selectIndex">

                    <el-tab-pane name="2" label="密码登入">
                        <el-form :model="passForm" :rules="rules" ref="passForm">
                            <el-form-item >
                                <el-input placeholder="请输入手机号、账号" v-model="passForm.phone" clearable prefix-icon="el-icon-user"></el-input>
                            </el-form-item>
                            <el-form-item prop="pass">
                                <el-input placeholder="请输入密码" v-model="passForm.pass" clearable show-password prefix-icon="el-icon-lock"></el-input>
                            </el-form-item>
                            <el-form-item prop="agreement">
                                <el-checkbox v-model="passForm.agreement">阅读并接受</el-checkbox>
                                <span class="agreement" @click="agreement">《用户服务协议》</span>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="submitForm_pass('passForm')" :loading="btnLoading" class="login_btn">{{loginBtnTxt}}</el-button>

                            </el-form-item>
                          <div style="text-align: center;">还没有账号？ <router-link to="/reg" style="color:#000;">注册账号</router-link></div>
                        </el-form>
                    </el-tab-pane>

                </el-tabs>
            </el-card>
        </el-main>
        <el-footer><div class="copyright">Copyright &copy; 2018-2020  版权所有</div></el-footer>
        <agreement ref="agreement"></agreement>
        <el-dialog title="提示" :visible.sync="captchaDialog" center :close-on-click-modal="false" :close-on-press-escape="false" width="400px">
            <span>
                <span class="captcha-lab">验证码：</span>
                <el-input class="captcha-inp" v-model="captcha" maxlength="4" clearable placeholder="请输入右边验证码"></el-input>
                <img class="captcha-img" :src="captchaUrl" alt="点我刷新" @click="refreshRanCode">
            </span>
            <span slot="footer">
                <el-button @click="captchaDialog=false">取 消</el-button>
                <el-button type="primary" @click="captchaVerification">确 定</el-button>
            </span>
        </el-dialog>
    </el-container>
</template>

<script>
    import agreement from "../../components/agreement";
    import QRCode from 'qrcodejs2';
    import apiConfig from "../../api/api.config";

    export default {
        name: "login",
        data() {
            let phone = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入手机号码'));
                } else if (value.match(/^\d{11}$/) == null) {
                    callback(new Error('请输入正确的手机号'));
                } else {
                    callback();
                }
            };
            let code = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入验证码'));
                } else if (value.match(/^\d{6}$/) == null) {
                    callback(new Error('请输入六位验证码'));
                } else {
                    callback();
                }
            };
            let pass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入密码'));
                } else if (value.length < 5 || value.length > 20) {
                    callback(new Error('请输入正确的密码'));
                } else {
                    callback();
                }
            };
            let agreement = (rule, value, callback) => {
                if (value){
                    callback();
                } else {
                    callback(new Error('请阅读并勾选用户协议'));
                }
            };
            return {
                activeName: '2',
                time: 0,
                disabled: false,
                btnTxt: "获取验证码",
                btnLoading: false,
                loginBtnTxt: "登入",
                uniqueID: "",
                captcha: "",
                captchaUrl: "",
                captchaStr: "",
                captchaDialog: false,
                wxScene: "",
                wxInterval1: "",
                wxInterval2: "",
                wxQrCodeUrl: "",
                expireTxt: "未获取",
                expireSeconds: 0,
                codeForm: {
                  phone: '',
                  code: '',
                  agreement: true,
                },
                passForm: {
                  phone: '',
                  pass: '',
                  agreement: true,
                },
                rules: {
                  phone: [
                      { validator: phone, trigger: 'blur' }
                  ],
                  code: [
                      { validator: code, trigger: 'blur' }
                  ],
                  pass: [
                      { validator: pass, trigger: 'blur' }
                  ],
                  agreement: [
                      { validator: agreement, trigger: 'blur' }
                  ],
                },
            }
        },
        mounted() {
            const token = this.$store.state.token;
            const codeTime = this.$cookies.get('codeTime');
            const captchaStr = this.$cookies.get('captchaStr');

            if (token !== undefined && token !== null && token !== ''){
                this.$router.push('/tabs/index');
            }
            if (captchaStr !== undefined && captchaStr !== null && captchaStr !== ''){
                this.captchaStr = captchaStr;
            }
            if (codeTime > 0){
                console.log(codeTime);
                this.time = codeTime;
                this.timer();
            }
        },
        methods:{
            selectIndex() {
                const index = this.activeName;
                this.btnLoading = false;
                this.loginBtnTxt = "登入";
                if (index === '3'){
                    this.getWxQrCode();
                }else {
                    this.lClearInterval();
                }
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (formName === 'codeForm') {
                            this.codeLogin();
                        } else if (formName === 'passForm') {
                            this.login();
                        }
                    }
                });
            },
          submitForm_pass(formName) {
             if(this.passForm.phone==''){
               this.$message.error("请输入手机号或账号");
               return ;
             }
            if(this.passForm.pass==''){
              this.$message.error("请输入密码");
              return ;
            }
             this.login();
          },
            async login() {
                console.log('login');
                this.btnLoading = true;
                this.loginBtnTxt = "登入中...";
                let postdata = {
                    phone: this.passForm.phone,
                    pass: this.passForm.pass,
                    check: this.passForm.agreement,
                };
                const {ret,data} = await this.$api.passLogin(postdata);
                this.btnLoading = false;
                this.loginBtnTxt = "登入";
                if (ret === 1000){
                    this.$storeLocal.set('token',data.token);
                    this.$storeLocal.set('userInfo',data.user_info);
                    this.$store.state.token = data.token;
                    await this.$router.push('/tabs/index');
                }
            },
            async codeLogin() {
                console.log('codeLogin');
                this.btnLoading = true;
                this.loginBtnTxt = "登入中...";
                let postdata = {
                    phone: this.codeForm.phone,
                    code: this.codeForm.code,
                    check: this.codeForm.agreement,
                };
                const {ret,data} = await this.$api.login(postdata);
                this.btnLoading = false;
                this.loginBtnTxt = "登入";
                if (ret === 1000){
                    this.$storeLocal.set('token',data.token);
                    this.$storeLocal.set('userInfo',data.user_info);
                    this.$store.state.token = data.token;
                    this.$cookies.remove('codeTime');
                    await this.$router.push('/tabs/index');
                }
            },
            async wxLogin() {
                console.log('wxLogin');
                const scene = this.wxScene;
                if (scene === "") return;
                if (this.expireSeconds === 0) return;
                const {ret,data} = await this.$api.wxLogin({id:scene});
                if (ret === 1000){
                    this.$storeLocal.set('token',data.token);
                    this.$storeLocal.set('userInfo',data.user_info);
                    this.$store.state.token = data.token;
                    this.lClearInterval();
                    await this.$router.push('/tabs/index');
                }else if (ret === 488) {
                    this.lClearInterval();
                    await this.$router.push('/wxMpBind/'+data.id);
                }else if (ret === 489) {
                    setTimeout(this.wxLogin,2500);
                }else {
                    this.lClearInterval();
                }
            },
            async getWxQrCode() {
                const scene = this.wxScene;
                const {ret,data} = await this.$api.wxQrCode({id:scene});
                if (ret === 1000){
                    this.wxScene = data.scene;
                    this.wxQrCodeUrl = data.url;
                    this.expireSeconds = data.expireSeconds;
                    this.qrCodeCountTime();
                    this.bindQRCode();
                    this.wxLogin();
                }
            },
            async sendCode() {
                const phone = this.codeForm.phone;
                if (phone === ""){
                    this.$message.error("请输入手机号码！");
                    return;
                }
                if (phone.match(/^\d{11}$/) == null){
                    this.$message.error("请输入正确的手机号码！");
                    return;
                }
                if (this.captchaStr === "") {
                    this.refreshRanCode();
                    this.captchaDialog = true;
                    return;
                }
                const captcha = this.$cookies.get('captchaStr');
                const getData = {
                    phone: phone,
                    captcha: captcha,
                    unique_id: this.uniqueID,
                };
                const {ret} = await this.$api.sendSms(getData);
                if (ret === 1000){
                    this.time = 60;
                    this.timer();
                    this.$message.success("发送成功");
                }else if (ret === 4002){
                    this.refreshRanCode();
                    this.captchaStr = "";
                    this.captchaDialog = true;
                    this.$cookies.remove('captchaStr');
                }else {
                    console.log('send code error ...');
                }
            },
            async captchaVerification() {
                const vCode = this.captcha;
                const time = parseInt((new Date().getTime())/1000);
                if (vCode === ""){
                    this.$message.error("请填写验证码！");
                    return;
                }
                let ph = this.codeForm.phone;
                let sg = this.$common.captchaSign(ph,vCode,time);
                let getData = {
                    ph: ph,
                    sg: sg,
                    code: vCode,
                    time: time,
                    unique_id: this.uniqueID,
                };
                const {ret,data} = await this.$api.captcha(getData);
                if (ret === 1000){
                    this.captchaStr = data.keys;
                    this.$cookies.set('captchaStr',data.keys);
                    this.captchaDialog = false;
                    this.sendCode();
                }else if (ret === 4005){
                    this.refreshRanCode();
                }
            },
            async refreshRanCode() {
                const baseUrl = apiConfig.baseUrl;
                const {ret,data} = await this.$api.getCode();
                if (ret === 1000){
                    this.uniqueID = data.id;
                    this.captchaUrl = baseUrl+data.url;
                }else {
                    this.$message.error('出错了！请刷新重试');
                }
            },
            timer() {
                if(this.time > 0){
                    this.time--;
                    this.disabled = true;
                    this.btnTxt = this.time+"s后重新获取";
                }
                const auth_timer = setInterval(()=>{
                    if(this.time > 0){
                        this.time--;
                        this.disabled = true;
                        this.$cookies.set('codeTime',this.time);
                        this.btnTxt = this.time+"s后重新获取";
                    }else {
                        this.time = 0;
                        this.btnTxt = "获取验证码";
                        this.disabled = false;
                        this.$cookies.remove('codeTime');
                        clearInterval(auth_timer)
                    }
                },1000);
            },
            bindQRCode() {
                const txt = this.wxQrCodeUrl;
                if (txt === '') return;
                this.$refs.qrCodeDiv.innerHTML = '';
                new QRCode(this.$refs.qrCodeDiv, {
                    text: txt,
                    width: 200,
                    height: 200,
                    colorDark: "#333333", //二维码颜色
                    colorLight: "#ffffff", //二维码背景色
                    correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
                });
            },
            agreement() {
                this.$refs.agreement.show();
            },
            qrCodeCountTime() {
                let $this = this;
                let t = $this.expireSeconds-1;
                $this.expireTxt = Math.floor(Math.floor(t%3600)/60)+"分"+Math.floor(t%60)+"秒";
                $this.wxInterval1 = setInterval(function () {
                    const min = Math.floor(t%3600);
                    const minute = Math.floor(min/60);//分钟
                    const second = t%60 ;//秒
                    $this.expireTxt = minute+"分"+second+"秒";
                    if(t === 0){
                        $this.lClearInterval();
                        return;
                    }
                    t--;
                },1000);
            },
            lClearInterval() {
                if (this.expireSeconds > 0) this.expireSeconds = 0;
                if (this.wxInterval1 !== "") clearInterval(this.wxInterval1);
                if (this.wxInterval2 !== "") clearInterval(this.wxInterval2);
                this.$refs.qrCodeDiv.innerHTML = '';
            }
        },
        components: {
            agreement
        },
    }
</script>

<style scoped>
    .qrCode{
        width: 200px;
        height: 200px;
        margin: 0 auto;
        border: 1px solid #d7dae2;
        position: relative;
    }
    .el-container{
        width: 1200px;
        margin: 0 auto;
    }
    .header-left{
        display: inline-block;
        width: 130px;
        height: 48px;
        padding: 6px 0;
        vertical-align: top;
    }
    .header-left .logo{
        width: 130px;
    }
    .header-right{
        display: inline-block;
        width: 1000px;
        height: 22px;
        padding: 19px 0;
        margin-left: 30px;
        vertical-align: top;
        text-align: right;
    }
    .header-right .item{
        display: inline-block;
        height: 22px;
        text-align: center;
    }
    .header-right .item a{
        color: #666666;
    }
    .vcode{
        width: 200px;
        margin-right: 20px;
    }
    .sendBtn{
        width: 140px;
    }
    .login_btn{
        width: 100%;
    }
    .box-card{
        width: 400px;
        margin: 100px auto;
    }
    .countdown{
        width: 100%;
        height: 30px;
        font-size: 14px;
        text-align: center;
    }
    .code-div{
        width: 100%;
        height: 100%;
    }
    .image-slot{
        width: 200px;
        height: 200px;
        text-align: center;
        line-height: 200px;
        background-color: rgba(0,0,0,0.1);
        position: absolute;
        top: 0;
        left: 0;
    }
    .image-slot i{
        color: #808080;
        font-size: 50px;
    }
    .agreement{
        color: #409EFF;
        font-weight: 500;
        cursor: pointer;
    }
    .copyright{
        width: 100%;
        color: #666666;
        text-align: center;
    }
    .captcha-lab{
        display: inline-block;
        width: 60px;
        height: 40px;
        line-height: 40px;
        vertical-align: top;
    }
    .captcha-inp{
        display: inline-block;
        width: 170px;
        vertical-align: top;
    }
    .captcha-img{
        display: inline-block;
        width: 110px;
        height: 36px;
        padding: 2px 0;
        margin-left: 10px;
        vertical-align: top;
    }
</style>
